export default {
  constants: {
    APP_AION: "AION",
    APP_OASIS: "OASIS",
  },

//OASIS
  // apiGateway: {
  //   //DEV
  //   REGION: 'us-east-1',
  //   URL: 'https://odev.smartstakeapi.com/',
  //   GA_ID: "UA-169004578-4",
  //   ENV: "dev",
  //   APP: "OASIS",
  //   DEFAULT_POOL_ID: 23,
  //   TOOLS_HOME: "http://localhost:3000/",
  //   LOGO_BASE_PATH: "https://logo.smartstake.io/oasis/",
  //   URL_SPECIAL: 'https://prod.smartstakeapi.com/',
  // },

  apiGateway: {
   //PROD
    REGION: 'us-east-1',
    URL: 'https://oprod.smartstakeapi.com/',
    GA_ID: "UA-169004578-4",
    ENV: "prod",
    APP: "OASIS",
    DEFAULT_POOL_ID: 21,
    TOOLS_HOME: "http://oasis.smartstake.io/",
    LOGO_BASE_PATH: "https://logo.smartstake.io/oasis/",
    URL_SPECIAL: 'https://prod.smartstakeapi.com/',
  },
};



// WEBPACK FOOTER //
// ./src/config.js